/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import { Menu, Transition } from '@headlessui/react';
import { ChevronDownIcon, ChevronUpIcon } from '@heroicons/react/solid';
import jwt_decode from 'jwt-decode';
import React, { Fragment, useEffect, useRef, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';

import { useAuth } from '../contexts/AuthContext';
import { useHeaderContext } from '../contexts/HeaderContext';

function NavBarAreaLogada() {
    const Menus = [
        {
            title: 'Início',
            path: '/area-logada/',
            src: <IconHome active={location.pathname === '/area-logada/'} />,
        },
        {
            title: 'Suporte',
            path: '/area-logada/suporte',
            src: (
                <IconSuporte
                    active={location.pathname === '/area-logada/suporte'}
                />
            ),
        },
    ];
    const history = useNavigate();

    const { logout } = useAuth();

    const { setElementeSize } = useHeaderContext();

    const userSessionRef = useRef(null);

    function classNames(...classes: any) {
        return classes.filter(Boolean).join(' ');
    }

    const [isOpen, setIsOpen] = useState(false);

    const [whereIs, setWhereIs] = useState('');

    const [isLinked, setIsLinked] = useState(false);

    const user =
        sessionStorage.getItem('@grana-extra') !== 'null'
            ? JSON.parse(sessionStorage.getItem('@grana-extra') || '{}') || {
                  user: { name: 'Joaquim Bira' },
              }
            : JSON.parse(localStorage.getItem('@grana-extra') || '{}') || {
                  user: { name: 'Joaquim Bira' },
              };

    const decodeJwt: any = jwt_decode(user.access_token);

    const userName = decodeJwt.response.name;

    const userAvatar =
        userName.split(' ').length > 1
            ? userName.split(' ')[0].charAt(0).toUpperCase() +
              userName?.split(' ')[1].charAt(0).toUpperCase()
            : userName.split(' ')[0].charAt(0).toUpperCase() +
              userName?.split(' ')[0].charAt(0).toUpperCase();

    useEffect(() => {
        const path = window.location.pathname;
        setWhereIs(path);
    });

    useEffect(() => {
        const decodedJwt: any = jwt_decode(user.access_token);

        setIsLinked(decodedJwt.response.isLinked);
    }, []);

    useEffect(() => {
        if (userSessionRef.current) {
            const width = userSessionRef.current.clientWidth + 80;
            setElementeSize(String(width));
        }
    }, [userSessionRef]);

    return (
        <div className="static">
            <nav className="bg-dark-blue p-[16px] pb-2 relative">
                <div className="mx-auto px-0 sm:px-6 lg:px-5">
                    <div className="flex items-center justify-between h-16 w-full">
                        <div className="flex items-center w-full justify-between pr-5">
                            <div className="flex-shrink-0">
                                <img
                                    alt=""
                                    width="128px"
                                    src="/images/logo-branco.png"
                                ></img>
                            </div>
                            <div className="hidden md:block ">
                                <div
                                    ref={userSessionRef}
                                    className="flex items-center text-white text-xs mt-2"
                                >
                                    <div className="rounded-full bg-primary p-2">
                                        {userAvatar}
                                    </div>
                                    {/* <p className="mx-5">Henrique Futema</p>
                    <img src="/images/seta-branca.svg"></img> */}
                                    <div>
                                        <Menu
                                            as="div"
                                            className="inline-block text-left"
                                        >
                                            <div>
                                                <Menu.Button className="inline-flex justify-center w-full rounded-md px-4 py-2 text-sm font-medium text-white max-w-[190px] max-h-[70px] overflow-y-hidden">
                                                    {userName}
                                                    <ChevronDownIcon
                                                        className="-mr-1 ml-2 h-5 w-5 text-white"
                                                        aria-hidden="true"
                                                    />
                                                </Menu.Button>
                                            </div>

                                            <Transition
                                                as={Fragment}
                                                enter="transition ease-out duration-100"
                                                enterFrom="transform opacity-0 scale-95"
                                                enterTo="transform opacity-100 scale-100  relative z-50"
                                                leave="transition ease-in duration-75"
                                                leaveFrom="transform opacity-100 scale-100  relative z-50"
                                                leaveTo="transform opacity-0 scale-95"
                                            >
                                                <Menu.Items
                                                    className="origin-top-right top-[88px] right-[50px] w-[15rem] rounded-md shadow-lg bg-white ring-1 ring-black ring-opacity-5 focus:outline-none rounded-t-none absolute"
                                                    style={{
                                                        position: 'absolute',
                                                    }}
                                                >
                                                    <div className="py-1">
                                                        <Menu.Item>
                                                            {({ active }) => (
                                                                <button
                                                                    onClick={() => {}}
                                                                    className={classNames(
                                                                        'block w-full text-left px-4 py-2 text-sm'
                                                                    )}
                                                                >
                                                                    <p className="text-xl text-dark-blue">
                                                                        Olá,{' '}
                                                                        {
                                                                            userName
                                                                        }
                                                                    </p>
                                                                </button>
                                                            )}
                                                        </Menu.Item>
                                                        <hr className="my-2 h-0.5 border-t-0 bg-[#D2D2D2] opacity-100 dark:opacity-50" />
                                                        <div className="text-[#828282] px-4 text-[1rem] my-4">
                                                            Minha conta
                                                        </div>
                                                        {whereIs.includes(
                                                            '/area-logada/propostas'
                                                        ) &&
                                                            isLinked && (
                                                                <Menu.Item>
                                                                    {({
                                                                        active,
                                                                    }) => (
                                                                        <button
                                                                            onClick={() => {
                                                                                history(
                                                                                    '/area-logada/leads'
                                                                                );
                                                                            }}
                                                                            className={classNames(
                                                                                active
                                                                                    ? 'bg-gray-100 text-gray-900'
                                                                                    : 'text-gray-700',
                                                                                'block w-full text-left px-4 py-2 text-sm'
                                                                            )}
                                                                        >
                                                                            <div className="flex gap-4 items-center pt-2">
                                                                                <span className="text-2xl">
                                                                                    <IconPersonagem />
                                                                                </span>
                                                                                <span className="text-dark-blue font-bold text-base	">
                                                                                    Acessar
                                                                                    painel
                                                                                    Gestão
                                                                                    de
                                                                                    Leads
                                                                                </span>
                                                                            </div>
                                                                        </button>
                                                                    )}
                                                                </Menu.Item>
                                                            )}
                                                        {whereIs ===
                                                            '/area-logada/leads' && (
                                                            <Menu.Item>
                                                                {({
                                                                    active,
                                                                }) => (
                                                                    <button
                                                                        onClick={() => {
                                                                            history(
                                                                                '/area-logada/propostas'
                                                                            );
                                                                        }}
                                                                        className={classNames(
                                                                            active
                                                                                ? 'bg-gray-100 text-gray-900'
                                                                                : 'text-gray-700',
                                                                            'block w-full text-left px-4 py-2 text-sm'
                                                                        )}
                                                                    >
                                                                        <div className="flex gap-4 items-center pt-2">
                                                                            <span className="text-2xl">
                                                                                <IconPersonagem />
                                                                            </span>
                                                                            <span className="text-dark-blue font-bold text-base	">
                                                                                Acessar
                                                                                painel
                                                                                Grana
                                                                                Extra
                                                                            </span>
                                                                        </div>
                                                                    </button>
                                                                )}
                                                            </Menu.Item>
                                                        )}
                                                        <Menu.Item>
                                                            {({ active }) => (
                                                                <button
                                                                    onClick={() => {
                                                                        logout();
                                                                        history(
                                                                            '/'
                                                                        );
                                                                    }}
                                                                    className={classNames(
                                                                        active
                                                                            ? 'bg-gray-100 text-gray-900'
                                                                            : 'text-gray-700',
                                                                        'block w-full text-left px-4 py-2 text-sm'
                                                                    )}
                                                                >
                                                                    <div className="flex gap-4 items-center pt-2">
                                                                        <span className="text-2xl">
                                                                            <IconSair />
                                                                        </span>
                                                                        <span className="text-dark-blue font-bold text-base	">
                                                                            Sair
                                                                        </span>
                                                                    </div>
                                                                </button>
                                                            )}
                                                        </Menu.Item>
                                                    </div>
                                                </Menu.Items>
                                            </Transition>
                                        </Menu>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="-mr-2 flex md:hidden">
                            <button
                                onClick={() => setIsOpen(!isOpen)}
                                type="button"
                                className="inline-flex items-center justify-center p-2 rounded-md text-white"
                                aria-controls="mobile-menu"
                                aria-expanded="false"
                            >
                                <span className="sr-only">Open main menu</span>
                                {!isOpen ? (
                                    <svg
                                        className="block h-6 w-6"
                                        xmlns="http://www.w3.org/2000/svg"
                                        fill="none"
                                        viewBox="0 0 24 24"
                                        stroke="currentColor"
                                        aria-hidden="true"
                                    >
                                        <path
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                            strokeWidth="2"
                                            d="M4 6h16M4 12h16M4 18h16"
                                        />
                                    </svg>
                                ) : (
                                    <svg
                                        className="block h-6 w-6"
                                        xmlns="http://www.w3.org/2000/svg"
                                        fill="none"
                                        viewBox="0 0 24 24"
                                        stroke="currentColor"
                                        aria-hidden="true"
                                    >
                                        <path
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                            strokeWidth="2"
                                            d="M6 18L18 6M6 6l12 12"
                                        />
                                    </svg>
                                )}
                            </button>
                        </div>
                    </div>
                </div>

                <Transition
                    show={isOpen}
                    enter="transition ease-out duration-100 transform"
                    enterFrom="opacity-0 scale-95"
                    enterTo="opacity-100 scale-100 relative z-50"
                    leave="transition ease-in duration-75 transform"
                    leaveFrom="opacity-100 scale-100 relative z-50"
                    leaveTo="opacity-0 scale-95"
                >
                    {(ref) => (
                        <>
                            {' '}
                            <div
                                className="bg-white absolute top-2 max-w-[60%] z-10"
                                id="mobile-menu"
                            >
                                <div className="flex items-center gap-2 p-4">
                                    <div className="rounded-full bg-primary p-2 text-white w-12">
                                        {userAvatar}
                                    </div>
                                    <p className="text-xl text-dark-blue">
                                        Olá, {userName}
                                    </p>
                                </div>

                                <div
                                    ref={ref}
                                    className="px-2 pt-10 pb-3 space-y-7 sm:px-3 flex flex-col text-dark-blue"
                                >
                                    {Menus.map((menu, index) => (
                                        <Link to={menu.path} key={index}>
                                            <li
                                                className={`text-sm flex h-12 items-center justify-between gap-x-3 py-3 pl-2 text-base cursor-pointer dark:text-white hover:opacity-80
                                   ${
                                       location.pathname === menu.path &&
                                       'text-blue font-bold'
                                   }`}
                                            >
                                                <div className="flex gap-4 items-center">
                                                    <span className="text-2xl">
                                                        {menu.src}
                                                    </span>
                                                    <span
                                                        className={`text-dark-blue
                                      ${
                                          location.pathname === menu.path &&
                                          'text-blue font-bold'
                                      }                                
                                    `}
                                                    >
                                                        {menu.title}
                                                    </span>
                                                </div>
                                                {location.pathname ===
                                                    menu.path && (
                                                    <div className="bg-blue h-12 w-[5px] rounded-l-lg" />
                                                )}
                                            </li>
                                        </Link>
                                    ))}
                                    <Link
                                        className="mx-2"
                                        to={{ pathname: '/' }}
                                    >
                                        <button onClick={logout}>
                                            <div className="flex gap-4 items-center pt-2">
                                                <span className="text-2xl">
                                                    <IconSair />
                                                </span>
                                                <span className="text-dark-blue font-bold text-base	">
                                                    Sair
                                                </span>
                                            </div>
                                        </button>
                                    </Link>
                                </div>
                            </div>
                            <div
                                onClick={() => setIsOpen(!isOpen)}
                                className="bg-[#21212475] fixed h-[100vh] w-[100vw]"
                            ></div>
                        </>
                    )}
                </Transition>
            </nav>
        </div>
    );
}

interface IIcons {
    active: boolean;
}

function IconHome({ active }: IIcons) {
    return (
        <svg
            width="22"
            height="25"
            viewBox="0 0 22 25"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M20.3061 22.4477C20.3061 22.9188 19.9264 23.3005 19.4606 23.3005H15.3727V17.7815C15.3727 17.4059 15.3252 17.0332 15.2303 16.6724C15.1413 16.3235 15.0108 15.9896 14.8387 15.6735C14.0734 14.2632 12.6019 13.3837 11 13.3837C8.97681 13.3837 7.26807 14.7731 6.76969 16.6545C6.67476 17.0153 6.62433 17.3939 6.62433 17.7815V23.3005H2.53937C2.07066 23.3005 1.69094 22.9188 1.69094 22.4477V9.63878C1.69094 9.38534 1.80367 9.14681 1.99649 8.98581L10.4571 1.89854C10.6143 1.76735 10.8072 1.70175 11 1.70175C11.1928 1.70175 11.3827 1.76735 11.5399 1.89854L20.0005 8.98581C20.1963 9.14681 20.3061 9.38534 20.3061 9.63878V22.4477ZM13.5839 23.3005H8.41613V17.7815C8.41613 17.6205 8.43096 17.4595 8.46062 17.3075C8.68312 16.0999 9.73624 15.1846 11 15.1846C11.9463 15.1846 12.8155 15.7004 13.2665 16.5382C13.394 16.7708 13.486 17.0242 13.5364 17.2836C13.569 17.4476 13.5839 17.6146 13.5839 17.7815V23.3005ZM21.0863 7.67986L12.6227 0.592594C11.6823 -0.197531 10.3147 -0.197531 9.37433 0.592594L0.913698 7.67986C0.332253 8.16587 0 8.87847 0 9.63878V22.4477C0 23.8551 1.13916 25 2.53937 25H19.4606C20.8608 25 22 23.8551 22 22.4477V9.63878C22 8.87847 21.6648 8.16587 21.0863 7.67986Z"
                fill={`${active ? '#0066F3' : '#001E64'}`}
            />
        </svg>
    );
}

function IconSuporte({ active }: IIcons) {
    return (
        <svg
            width="26"
            height="24"
            viewBox="0 0 26 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M2.93945 12.7256V10.891C2.93945 5.42678 7.36634 0.99958 12.8309 0.99958C15.5632 0.99958 18.0353 2.10709 19.8283 3.89689C21.618 5.68668 22.7256 8.15876 22.7256 10.891V12.7256"
                stroke={`${active ? '#0066F3' : '#001E64'}`}
                strokeWidth="2"
                strokeMiterlimit="10"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M1 17.1815C1 20.1011 3.36672 22.4678 6.28624 22.4678V11.8953C3.36672 11.8953 1 14.262 1 17.1815Z"
                stroke={`${active ? '#0066F3' : '#001E64'}`}
                strokeWidth="2"
                strokeMiterlimit="10"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M24.5792 17.1815C24.5792 20.1011 22.2125 22.4678 19.293 22.4678V11.8953C22.2125 11.8953 24.5792 14.262 24.5792 17.1815Z"
                stroke={`${active ? '#0066F3' : '#001E64'}`}
                strokeWidth="2"
                strokeMiterlimit="10"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
}

function IconSair() {
    return (
        <svg
            width="32"
            height="32"
            viewBox="0 0 32 32"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M18.2052 28C13.8489 28 10.3047 24.4558 10.3047 20.0994C10.3047 19.6115 10.7001 19.2164 11.1877 19.2164C11.6753 19.2164 12.0707 19.6115 12.0707 20.0994C12.0707 23.482 14.8227 26.234 18.2052 26.234C21.5881 26.234 24.3401 23.482 24.3401 20.0994V11.9006C24.3401 8.51802 21.5881 5.76599 18.2052 5.76599C14.8227 5.76599 12.0707 8.51802 12.0707 11.9006C12.0707 12.3882 11.6753 12.7836 11.1877 12.7836C10.7001 12.7836 10.3047 12.3882 10.3047 11.9006C10.3047 7.54422 13.8489 4 18.2052 4C22.5616 4 26.1061 7.54422 26.1061 11.9006V20.0994C26.1061 24.4558 22.5616 28 18.2052 28Z"
                fill="#001E64"
            />
            <path
                d="M15.9051 16.8156C13.8408 16.8156 7.83829 16.8178 5.90493 16.8141C5.34188 16.813 4.99773 16.4939 5.00001 15.9972C5.00257 15.5025 5.347 15.1913 5.91489 15.1905C7.70109 15.1871 13.5564 15.1891 15.3426 15.1891H15.8954C15.42 14.7134 15.0161 14.3098 14.6128 13.9056C14.4312 13.7237 14.2402 13.5497 14.0722 13.3559C13.7693 13.006 13.791 12.5247 14.1075 12.2218C14.4107 11.9315 14.8815 11.9127 15.2111 12.2122C15.5615 12.5301 15.8869 12.876 16.2219 13.2104C16.9207 13.909 17.6213 14.6055 18.3167 15.3072C18.8077 15.8028 18.8063 16.2053 18.3098 16.7043C17.3363 17.6832 16.3594 18.6584 15.3822 19.6331C14.9418 20.072 14.4556 20.1235 14.1004 19.7757C13.7414 19.4247 13.7844 18.9308 14.2188 18.4947C14.7505 17.9604 15.2871 17.4307 15.9051 16.8156Z"
                fill="#001E64"
            />
        </svg>
    );
}
function IconPersonagem() {
    return (
        <svg
            width="32"
            height="32"
            viewBox="0 0 32 32"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <g clipPath="url(#clip0_3437_45827)">
                <path
                    d="M20.0404 16.7398C21.3938 15.8448 22.4286 14.524 22.99 12.9751C23.5514 11.4262 23.6091 9.73236 23.1546 8.14696C22.7001 6.56156 21.7578 5.16978 20.4686 4.17979C19.1794 3.18979 17.6126 2.65479 16.0025 2.65479C14.3924 2.65479 12.8256 3.18979 11.5364 4.17979C10.2472 5.16978 9.30487 6.56156 8.85037 8.14696C8.39587 9.73236 8.45363 11.4262 9.01499 12.9751C9.57636 14.524 10.6112 15.8448 11.9647 16.7398C10.0056 17.5637 8.32933 18.9666 7.14872 20.7704C5.96812 22.5741 5.33646 24.6974 5.33398 26.8704C5.33422 27.3639 5.36648 27.8569 5.43056 28.346C5.47096 28.6493 5.6271 28.9238 5.86466 29.109C6.10221 29.2942 6.40171 29.3749 6.69727 29.3335C6.99282 29.292 7.26023 29.1317 7.44066 28.8879C7.62109 28.6441 7.69976 28.3367 7.65936 28.0333C7.60786 27.6543 7.58179 27.2721 7.58136 26.8895C7.55779 25.7368 7.75863 24.591 8.17208 23.519C8.58554 22.4471 9.2033 21.4706 9.98916 20.6469C10.775 19.8232 11.7132 19.1688 12.7486 18.722C13.7841 18.2752 14.896 18.0451 16.0192 18.0451C17.1424 18.0451 18.2544 18.2752 19.2898 18.722C20.3253 19.1688 21.2634 19.8232 22.0493 20.6469C22.8351 21.4706 23.4529 22.4471 23.8664 23.519C24.2798 24.591 24.4807 25.7368 24.4571 26.8895C24.4567 27.2721 24.4306 27.6543 24.3791 28.0333C24.3592 28.1823 24.3681 28.3338 24.4054 28.4793C24.4426 28.6247 24.5074 28.7611 24.5961 28.8808C24.6848 29.0005 24.7955 29.1011 24.9221 29.1768C25.0487 29.2525 25.1886 29.3019 25.3338 29.322C25.3845 29.3258 25.4354 29.3258 25.4861 29.322C25.757 29.3246 26.0196 29.2258 26.2247 29.0441C26.4299 28.8623 26.5634 28.61 26.6005 28.3345C26.6645 27.8454 26.6968 27.3525 26.697 26.859C26.6902 24.6848 26.0537 22.5619 24.8684 20.76C23.6831 18.9582 22.0025 17.5588 20.0404 16.7398ZM16.0025 4.95448C17.0362 4.95448 18.0467 5.2691 18.9062 5.85857C19.7657 6.44804 20.4356 7.28588 20.8312 8.26613C21.2268 9.24638 21.3303 10.325 21.1286 11.3657C20.927 12.4063 20.4292 13.3622 19.6982 14.1124C18.9673 14.8627 18.036 15.3736 17.0222 15.5806C16.0083 15.7876 14.9574 15.6814 14.0024 15.2753C13.0474 14.8693 12.2311 14.1817 11.6568 13.2995C11.0825 12.4173 10.776 11.3801 10.776 10.3191C10.777 8.89661 11.3279 7.53269 12.3079 6.52685C13.2878 5.52101 14.6166 4.95549 16.0025 4.95448Z"
                    fill="#001E64"
                />
            </g>
            <defs>
                <clipPath id="clip0_3437_45827">
                    <rect
                        width="21.3333"
                        height="26.6667"
                        fill="white"
                        transform="translate(5.33398 2.66675)"
                    />
                </clipPath>
            </defs>
        </svg>
    );
}
export default NavBarAreaLogada;
